import _ from 'lodash';
import ApiToken from 'models/api_token';
import Err from 'models/err';

export default class RenameApiToken {
  constructor(context) {
    this.context = context;
  }

  run({ id, name }) {
    let apiToken = this.store.findBy({ id });
    if (!apiToken) {
      return; // possibly was removed by a different session during edit
    }

    let validationErrors = ApiToken.getValidationErrors({ name });
    if (_.find(this.store.findAll(), existing => id !== existing.id && _.trim(name) === _.trim(existing.name))) {
      validationErrors.push(new Err({ attr: 'name', code: Err.Code.TAKEN, detail: 'name already in use' }));
    }

    if (validationErrors.length) {
      this.store.setErrors(id, validationErrors);
      return;
    }

    name = name.trim();
    apiToken.rename(name);
    this.store.setPending(apiToken);
    this.context.gateways.apiToken.update(this.currentAgentId, id, { name });
  }

  get store() {
    return this.context.stores.apiTokens;
  }

  get currentAgentId() {
    return this.context.stores.currentAgent.get().id;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/api_tokens/rename_api_token.js